import React, { createContext, useState, useEffect }  from 'react';

import Unsplash from 'unsplash-js';
import { withFirebase } from '../Firebase';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import SaveIcon from '@material-ui/icons/Save';

import Copyright from '../Copyright';
import useStyles from '../../styles/styles'
import listStyles from '../../styles/listStyles'

import SuccessSnackbar from '../Snackbar/SnackbarSuccess';
import FailureSnackbar from '../Snackbar/SnackbarFailure';


export const Context = createContext({});

const Clarifai = require('clarifai');

const app = new Clarifai.App({ 
  apiKey: process.env.REACT_APP_CLARIFAI_KEY
});


const unsplash = new Unsplash({ accessKey: process.env.REACT_APP_UNSPLASH_KEY  });

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};



const UnsplashSearch = ({ firebase }) => {

  const query = new URLSearchParams(window.location.search).get('q');

  const classes = useStyles();
  const listClasses = listStyles();

  const [hasError, setErrors] = useState(false);
  const [items, setItems] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);
  const [searchItem, setSearchItem] = useState(query || 'beach' );
  const [searchHistory, setSearchHistory] = useState([]);
  const [savedImages, setSavedImages] = useState([]);
  const [similarImages, setSimilarImages] = useState([]);
  const [ uploadError, setUploadError ] = useState('');
  const [ displayMessage, setDisplayMessage ] = useState('')


  useEffect(
    () => {
      if(searchItem){ 
        unsplashAPI(searchItem);
        if(firebase.currentUser) {
          var user = firebase.currentUser;
          firebase.getSearchHistory(user.uid).then((currentSearchItems) => {
            if (currentSearchItems.length === 0 || currentSearchItems[currentSearchItems.length -1] !== searchItem) {
              currentSearchItems.push(searchItem);
            }
            return firebase.saveSearchHistory(user.uid, currentSearchItems)
          })
        }
            window.history.pushState(null, null, `?q=${searchItem}`)  
      }
  }, [searchItem, firebase.currentUser ]);

  useEffect(
    () => {
      if(displayMessage)
      {
      setTimeout(() => setDisplayMessage(''), 1000)
      }
    }, [ displayMessage ]
  )

  useEffect(
    () => {
      if(firebase.currentUser) {
        var user = firebase.currentUser;
        firebase.getSearchHistory(user.uid).then((searchHistory) => {
          setSearchHistory(searchHistory)
        })
        firebase.getSavedImages(user.uid).then((savedImages) => {
          setSavedImages(savedImages)
        })
      }
    }, [ firebase.currentUser, firebase.db ]
  )

  const filterList = (event) => {
    if(event.target.value) {
      console.log(event.target.value)
      let formItem = event.target.value;
      debounce(() => setSearchItem(formItem), 200);
    }
  }

  const saveImage = (image) => {
    if(!savedImages.includes(image)) {
      const newImages = [...savedImages, image]
      firebase.saveImages(firebase.currentUser.uid, newImages).then(
        () => setSavedImages(newImages)
      )
      setDisplayMessage('saved')
    }

    if(savedImages.includes(image)) {
      setDisplayMessage('duplicate')
    }
  }

  const findSimilarImages = (image) => {
    app.models.initModel({id: Clarifai.GENERAL_MODEL, version: "aa7f35c01e0642fda5cf400f543e7c40"})
      .then(generalModel => {
        return generalModel.predict(image);
      })
      .then(response => {
        var concepts = response['outputs'][0]['data']['concepts']
        let similarImageArray = [];
        concepts.map(element => similarImageArray.push((element.name)));
        setSimilarImages(similarImageArray);
      })
  }

  function unsplashAPI(searchItem) {
    unsplash.search.photos(searchItem, 1, 9, { orientation: 'portrait'})
      .then(res => res.json())
      .then(json => setItems(json))
      .then(setIsLoaded(true))
      .catch(err => setErrors(err))
  }

   

  if(!isLoaded) {
    return(
      <div>loading...</div>
    )
  }

  else {
      return (
        <React.Fragment>
          <CssBaseline />

          <main>
            {/* Hero unit */}
            <div className={classes.heroContent}>
              <Container maxWidth="sm">
                <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                 Free Image Search
                </Typography>
                <Typography variant="h5" align="center" color="textSecondary" paragraph>
                  Search and download free images without copyright
                </Typography>
                <form className={classes.root}>     
                  <TextField 
                    id="outlined-basic" 
                    label="Search" 
                    variant="outlined"
                    defaultValue={searchItem} 
                    name="q"
                    />
                    <Button onClick={filterList} variant="outlined" size="large" color="secondary" type="submit">
                       Search
                    </Button>
                </form>
              </Container>
              <Container className={classes.cardGrid}  maxWidth="sm">
                <Typography variant="h4" align="center" color="textPrimary" gutterBottom >
                 { (similarImages.length > 0 ? <p>Tags</p> : <p></p>)}
                </Typography>  
                <Grid container spacing={2}>
                { (similarImages.length > 0 ? similarImages.map(item => (
                  <Grid item key={item} xs={12} sm={6} md={4}>
                  <Typography component="h5" variant="h5" align="center" color="textPrimary" gutterBottom>
                    <Link href={`/?q=${item}`} color="primary">{item}</Link>
                 </Typography>
                  </Grid>
                ))  : console.log('No tags'))
              }
              </Grid>
              </Container>
            </div>
            <Container className={classes.cardGrid} maxWidth="md">
              <Grid container spacing={4}>
                { (items.results ? items.results.map(item => (
                  <Grid item key={item.id} xs={12} sm={6} md={4}>
                    <Card className={classes.card}>
                      <CardMedia
                        className={classes.cardMedia}
                        image={item.urls.small}
                        title={item.alt_description}
                      />
                      <CardContent className={classes.cardContent}>
                      </CardContent>
                      <CardActions>
                        <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                        onClick={() => saveImage(item.urls.small) }
                      >
                        Save
                      </Button>
                        <Button variant="outlined" onClick={() => findSimilarImages(item.urls.small) }>
                        Similar
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))  : console.log('error'))
              }
              {displayMessage === 'saved' && <SuccessSnackbar message={'Saved'} />}
              {displayMessage === 'duplicate' && <FailureSnackbar message={'Already In Album'} />}
              </Grid>
            </Container>
          </main>
          {/* Footer */}
          <footer className={classes.footer}>
            <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
              Machine Learning Image Search
            </Typography>
            <Copyright />
          </footer>
          {/* End footer */}
        </React.Fragment>
      );
    }
}


export default withFirebase(UnsplashSearch);